export const fr_38 = {
    'menu': {
        'dashboard': 'Mon compte',
        "account": "Menu",
    },
    'receipt': {
        'i_have_coupon': "J’ai un bon de reduction",
    }
}